import { STATE_TAX_DATA } from '../calculations'

// MERIC 2025 Annual Average Cost of Living indices by category
// Source: Missouri Economic Research and Information Center (MERIC)
// US average = 100 for each category
interface StateCOLData {
  grocery: number
  housing: number
  utilities: number
  transportation: number
  healthcare: number
  misc: number
  composite: number
}

const STATE_COL_BY_CATEGORY: Record<string, StateCOLData> = {
  AL: { grocery: 98.5, housing: 71.4, utilities: 103.7, transportation: 91.9, healthcare: 91.3, misc: 93.4, composite: 88.1 },
  AK: { grocery: 126.5, housing: 131.8, utilities: 169.5, transportation: 115.2, healthcare: 148.0, misc: 108.6, composite: 127.1 },
  AZ: { grocery: 97.2, housing: 107.0, utilities: 107.1, transportation: 100.8, healthcare: 95.3, misc: 99.6, composite: 102.2 },
  AR: { grocery: 95.3, housing: 72.9, utilities: 99.4, transportation: 89.6, healthcare: 88.7, misc: 93.2, composite: 87.0 },
  CA: { grocery: 109.3, housing: 199.4, utilities: 140.5, transportation: 136.8, healthcare: 104.2, misc: 116.6, composite: 138.5 },
  CO: { grocery: 100.5, housing: 118.5, utilities: 96.7, transportation: 101.3, healthcare: 102.4, misc: 102.5, composite: 105.0 },
  CT: { grocery: 106.7, housing: 118.4, utilities: 130.7, transportation: 107.9, healthcare: 108.5, misc: 106.4, composite: 112.7 },
  DE: { grocery: 103.8, housing: 99.4, utilities: 106.3, transportation: 104.4, healthcare: 106.9, misc: 99.7, composite: 101.5 },
  DC: { grocery: 111.3, housing: 224.1, utilities: 103.5, transportation: 116.4, healthcare: 110.8, misc: 118.7, composite: 148.7 },
  FL: { grocery: 102.8, housing: 107.2, utilities: 101.9, transportation: 105.5, healthcare: 98.6, misc: 100.5, composite: 102.8 },
  GA: { grocery: 97.0, housing: 82.1, utilities: 100.5, transportation: 99.5, healthcare: 95.8, misc: 96.0, composite: 93.4 },
  HI: { grocery: 131.4, housing: 299.0, utilities: 194.1, transportation: 141.5, healthcare: 127.8, misc: 122.5, composite: 192.9 },
  ID: { grocery: 96.3, housing: 101.8, utilities: 87.2, transportation: 91.4, healthcare: 97.3, misc: 97.5, composite: 98.4 },
  IL: { grocery: 99.1, housing: 80.3, utilities: 101.9, transportation: 105.0, healthcare: 100.4, misc: 97.5, composite: 93.4 },
  IN: { grocery: 97.9, housing: 77.7, utilities: 99.8, transportation: 95.9, healthcare: 96.0, misc: 95.2, composite: 90.5 },
  IA: { grocery: 96.1, housing: 76.3, utilities: 100.5, transportation: 96.4, healthcare: 96.3, misc: 95.3, composite: 89.6 },
  KS: { grocery: 95.6, housing: 75.0, utilities: 105.6, transportation: 93.8, healthcare: 96.4, misc: 93.8, composite: 88.7 },
  KY: { grocery: 96.1, housing: 76.9, utilities: 101.5, transportation: 95.0, healthcare: 93.1, misc: 95.4, composite: 90.6 },
  LA: { grocery: 99.0, housing: 77.8, utilities: 97.4, transportation: 95.1, healthcare: 93.1, misc: 95.5, composite: 91.1 },
  ME: { grocery: 105.8, housing: 120.5, utilities: 114.6, transportation: 107.2, healthcare: 111.4, misc: 105.7, composite: 112.1 },
  MD: { grocery: 107.1, housing: 134.3, utilities: 110.3, transportation: 108.8, healthcare: 96.8, misc: 104.2, composite: 115.3 },
  MA: { grocery: 107.5, housing: 171.4, utilities: 127.3, transportation: 108.0, healthcare: 120.4, misc: 110.2, composite: 131.6 },
  MI: { grocery: 95.4, housing: 77.1, utilities: 102.5, transportation: 97.7, healthcare: 96.9, misc: 95.2, composite: 89.7 },
  MN: { grocery: 101.0, housing: 95.7, utilities: 97.8, transportation: 100.1, healthcare: 101.1, misc: 99.3, composite: 98.3 },
  MS: { grocery: 96.1, housing: 63.6, utilities: 97.6, transportation: 88.3, healthcare: 87.8, misc: 91.7, composite: 83.1 },
  MO: { grocery: 96.2, housing: 76.4, utilities: 101.9, transportation: 94.6, healthcare: 93.8, misc: 95.2, composite: 89.8 },
  MT: { grocery: 99.7, housing: 103.9, utilities: 84.6, transportation: 91.6, healthcare: 100.7, misc: 98.1, composite: 99.2 },
  NE: { grocery: 97.0, housing: 80.8, utilities: 97.2, transportation: 94.0, healthcare: 98.4, misc: 96.4, composite: 92.5 },
  NV: { grocery: 103.1, housing: 111.9, utilities: 93.5, transportation: 105.3, healthcare: 98.1, misc: 101.2, composite: 104.2 },
  NH: { grocery: 105.3, housing: 124.2, utilities: 116.5, transportation: 104.3, healthcare: 113.5, misc: 105.2, composite: 112.6 },
  NJ: { grocery: 107.8, housing: 121.8, utilities: 108.5, transportation: 113.5, healthcare: 106.6, misc: 106.1, composite: 115.2 },
  NM: { grocery: 97.1, housing: 85.4, utilities: 97.0, transportation: 93.5, healthcare: 93.7, misc: 96.6, composite: 93.2 },
  NY: { grocery: 109.5, housing: 165.9, utilities: 117.8, transportation: 113.2, healthcare: 106.2, misc: 110.1, composite: 128.7 },
  NC: { grocery: 99.1, housing: 89.2, utilities: 99.0, transportation: 95.9, healthcare: 100.5, misc: 97.2, composite: 95.8 },
  ND: { grocery: 97.9, housing: 81.2, utilities: 96.2, transportation: 98.5, healthcare: 104.7, misc: 97.4, composite: 94.3 },
  OH: { grocery: 99.4, housing: 75.8, utilities: 98.3, transportation: 97.6, healthcare: 97.0, misc: 96.7, composite: 89.8 },
  OK: { grocery: 96.1, housing: 71.7, utilities: 101.4, transportation: 91.3, healthcare: 92.4, misc: 93.2, composite: 86.7 },
  OR: { grocery: 104.3, housing: 135.3, utilities: 92.7, transportation: 112.0, healthcare: 107.2, misc: 103.2, composite: 113.1 },
  PA: { grocery: 103.6, housing: 87.7, utilities: 108.1, transportation: 101.6, healthcare: 98.3, misc: 97.5, composite: 97.0 },
  RI: { grocery: 103.2, housing: 108.7, utilities: 116.3, transportation: 101.2, healthcare: 107.3, misc: 101.9, composite: 105.4 },
  SC: { grocery: 99.5, housing: 87.2, utilities: 106.3, transportation: 92.3, healthcare: 100.4, misc: 97.3, composite: 95.8 },
  SD: { grocery: 100.5, housing: 87.2, utilities: 97.0, transportation: 95.8, healthcare: 102.2, misc: 97.3, composite: 95.4 },
  TN: { grocery: 96.4, housing: 79.4, utilities: 98.6, transportation: 92.5, healthcare: 93.2, misc: 95.2, composite: 90.7 },
  TX: { grocery: 95.3, housing: 79.4, utilities: 102.9, transportation: 92.9, healthcare: 96.8, misc: 95.2, composite: 92.1 },
  UT: { grocery: 98.0, housing: 110.0, utilities: 84.8, transportation: 96.1, healthcare: 96.5, misc: 99.1, composite: 101.9 },
  VT: { grocery: 106.5, housing: 126.9, utilities: 117.8, transportation: 107.8, healthcare: 112.1, misc: 106.7, composite: 114.5 },
  VA: { grocery: 101.5, housing: 109.3, utilities: 101.4, transportation: 99.4, healthcare: 93.9, misc: 100.9, composite: 103.7 },
  WA: { grocery: 106.5, housing: 137.5, utilities: 92.5, transportation: 114.0, healthcare: 108.2, misc: 105.0, composite: 115.0 },
  WV: { grocery: 96.5, housing: 61.6, utilities: 101.3, transportation: 94.5, healthcare: 92.7, misc: 93.3, composite: 84.1 },
  WI: { grocery: 98.6, housing: 82.2, utilities: 99.8, transportation: 97.3, healthcare: 101.6, misc: 96.6, composite: 93.2 },
  WY: { grocery: 99.1, housing: 78.4, utilities: 88.2, transportation: 97.0, healthcare: 101.1, misc: 97.0, composite: 92.1 },
}

interface CostOfLivingInput {
  currentState: string
  targetState: string
  currentSalary: number
  currentHousing: number // monthly rent/mortgage
}

export function calculateCostOfLiving(input: CostOfLivingInput) {
  const currentData = STATE_COL_BY_CATEGORY[input.currentState]
  const targetData = STATE_COL_BY_CATEGORY[input.targetState]

  // Fallback to composite=100 if state not found
  const currentComposite = currentData?.composite || 100
  const targetComposite = targetData?.composite || 100

  // Composite ratio for headline equivalent salary
  const colRatio = targetComposite / currentComposite
  const equivalentSalary = Math.round(input.currentSalary * colRatio)

  // Per-category ratios
  const categoryRatios = {
    housing: currentData && targetData ? targetData.housing / currentData.housing : colRatio,
    grocery: currentData && targetData ? targetData.grocery / currentData.grocery : colRatio,
    utilities: currentData && targetData ? targetData.utilities / currentData.utilities : colRatio,
    transportation: currentData && targetData ? targetData.transportation / currentData.transportation : colRatio,
    healthcare: currentData && targetData ? targetData.healthcare / currentData.healthcare : colRatio,
  }

  // Housing scales by housing-specific ratio
  const equivalentHousing = Math.round(input.currentHousing * categoryRatios.housing)

  // Tax comparison
  const currentTax = STATE_TAX_DATA.find(s => s.code === input.currentState)
  const targetTax = STATE_TAX_DATA.find(s => s.code === input.targetState)
  const currentStateTaxRate = currentTax?.rate || 0
  const targetStateTaxRate = targetTax?.rate || 0

  const currentStateTaxAmount = Math.round(input.currentSalary * (currentStateTaxRate / 100))
  const targetStateTaxAmount = Math.round(equivalentSalary * (targetStateTaxRate / 100))
  const taxDifference = targetStateTaxAmount - currentStateTaxAmount

  // Breakdown categories using per-category scaling
  // Base expense amounts as salary percentages (BLS Consumer Expenditure Survey proportions)
  const currentGroceries = Math.round(input.currentSalary * 0.10)
  const currentTransport = Math.round(input.currentSalary * 0.08)
  const currentUtilities = Math.round(input.currentSalary * 0.04)
  const currentHealthcare = Math.round(input.currentSalary * 0.06)

  const breakdown = [
    {
      category: 'Housing',
      current: input.currentHousing * 12,
      target: equivalentHousing * 12,
    },
    {
      category: 'State Tax',
      current: currentStateTaxAmount,
      target: targetStateTaxAmount,
    },
    {
      category: 'Groceries & Food',
      current: currentGroceries,
      target: Math.round(currentGroceries * categoryRatios.grocery),
    },
    {
      category: 'Transportation',
      current: currentTransport,
      target: Math.round(currentTransport * categoryRatios.transportation),
    },
    {
      category: 'Utilities',
      current: currentUtilities,
      target: Math.round(currentUtilities * categoryRatios.utilities),
    },
    {
      category: 'Healthcare',
      current: currentHealthcare,
      target: Math.round(currentHealthcare * categoryRatios.healthcare),
    },
  ]

  const salaryDifference = equivalentSalary - input.currentSalary
  const housingDifference = (equivalentHousing - input.currentHousing) * 12
  const isCheaper = colRatio < 1

  return {
    currentState: input.currentState,
    targetState: input.targetState,
    currentCOL: currentComposite,
    targetCOL: targetComposite,
    colRatio: Math.round(colRatio * 1000) / 10,
    equivalentSalary,
    equivalentHousing,
    salaryDifference,
    housingDifference,
    currentStateTaxRate,
    targetStateTaxRate,
    currentStateTaxAmount,
    targetStateTaxAmount,
    taxDifference,
    breakdown,
    isCheaper,
    percentDifference: Math.round((colRatio - 1) * 1000) / 10,
    categoryRatios,
  }
}
